import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { set } from 'lodash';


interface tasksState {
    allClient: any;
    loadTasks: boolean;
    task: any;
    popUpTreatmentModel: {
        show: boolean;
        type: number;
    };
    emailSubjectDetails: string;
    typeTreatmentsAction: string;
    emailMessageId: string;
    treatmentId: string;

    createTreatmentFrom: {
        type: string;
        id: string;
    };
    taskStatusNotification: boolean; // New property to track task status notifications
    popUpTreatmentSuesModel: {
        show: boolean;
        type: number;
    };
    reloadSuesTreatments: boolean;
    reloadClientTreatments: {show: boolean, id: string}; // Changed to an object to track by entity
    treatmentListStore: any[]; // New property to store treatment list
    allRowsCounter: number;
}

const initialState: tasksState = {
    allClient: null,
    loadTasks: false,
    task: null,
    popUpTreatmentModel: {
        show: false,
        type: 0
    },
    emailSubjectDetails: '',
    typeTreatmentsAction: 'new',
    emailMessageId: '',
    treatmentId: '',

    createTreatmentFrom:{
        type: '',
        id: ''
    },
    taskStatusNotification: false, // Initialize the new property
    popUpTreatmentSuesModel: {
        show: false,
        type: 0
    },
    reloadSuesTreatments: false,
    reloadClientTreatments: {show: false, id: ''}, // Changed to an object to track by entity
    treatmentListStore: [], // Initialize the new property
    allRowsCounter: 0,
}

export const tasksSlice = createSlice({
    name: 'tasksSlice',
    initialState,
    reducers: {

        setAllClient: (state, action: PayloadAction<any>) => {

            console.log('action.payload', action.payload)
            state.allClient = { ...action.payload };
        },
        setLoadTasks: (state, action: PayloadAction<boolean>) => {
            state.loadTasks = action.payload;
        },
        setTask: (state, action: PayloadAction<any>) => {
            state.task = action.payload
        },
        setPopUpTreatmentModel: (state, action: PayloadAction<any>) => {
            state.popUpTreatmentModel = {...action.payload}
        },
        setEmailSubjectDetails: (state, action: PayloadAction<string>) => {
            state.emailSubjectDetails = action.payload;
        },
        setTypeTreatmentsAction: (state, action: PayloadAction<string>) => {
            state.typeTreatmentsAction = action.payload;
        },
        setEmailMessageId: (state, action: PayloadAction<string>) => {
            state.emailMessageId = action.payload;
        },
        setTreatmentId: (state, action: PayloadAction<string>) => {
            state.treatmentId = action.payload;
        },
        setCreateTreatmentFrom: (state, action: PayloadAction<any>) => {
            
            state.createTreatmentFrom = {...action.payload}
        },
        setTaskStatusNotification: (state, action: PayloadAction<boolean>) => {
            state.taskStatusNotification = action.payload;
        },
        setPopUpTreatmentSuesModel: (state, action: PayloadAction<any>) => {
            state.popUpTreatmentSuesModel = {...action.payload}
        },
        setReloadSuesTreatments: (state, action: PayloadAction<boolean>) => {
            state.reloadSuesTreatments = action.payload;
        },
        setReloadClientTreatments: (state, action: PayloadAction<{show: boolean, id: string}>) => {
            state.reloadClientTreatments = {...action.payload};
        }
        ,setTreatmentListStore: (state, action: PayloadAction<any[]>) => {
            state.treatmentListStore = [...action.payload];
        },
        setAllRowsCounter: (state, action: PayloadAction<number>) => {
            state.allRowsCounter = action.payload;
        }
    },
})
export const { setAllClient, setLoadTasks, setTask, setPopUpTreatmentModel, setEmailSubjectDetails,
     setTypeTreatmentsAction, setEmailMessageId, setTreatmentId, setCreateTreatmentFrom, setTaskStatusNotification, setPopUpTreatmentSuesModel,
 setReloadSuesTreatments, setReloadClientTreatments, setTreatmentListStore, setAllRowsCounter} = tasksSlice.actions
export default tasksSlice.reducer